(function () {
  var el = document.getElementById('pdp-klaviyo-data');
  if (!el) return;

  var item;
  try { item = JSON.parse(el.textContent); } catch (e) { return; }

  var _learnq = window._learnq = window._learnq || [];

  function trackProductView() {
    if (typeof klaviyo !== 'undefined' && klaviyo.push) {
      klaviyo.push(['track', 'Viewed Product', item]);
      _learnq.push(['track', 'Viewed Product', item]);
    } else {
      _learnq.push(['track', 'Viewed Product', item]);
    }
  }

  function onUserInteraction() {
    if (typeof window.isKlaviyoLoaded === 'function' && window.isKlaviyoLoaded()) {
      trackProductView();
      return;
    }
    if (typeof klaviyo !== 'undefined') {
      trackProductView();
      return;
    }
    window.addEventListener('klaviyoLoaded', trackProductView, { once: true });
  }

  document.addEventListener('click', onUserInteraction, { once: true, passive: true });
  document.addEventListener('mouseover', onUserInteraction, { once: true, passive: true });
  document.addEventListener('scroll', onUserInteraction, { once: true, passive: true });
  document.addEventListener('touchstart', onUserInteraction, { once: true, passive: true });

  if (typeof klaviyo !== 'undefined') {
    trackProductView();
  }
})();
